import isServer from '../isServer';

const isInIframe = () => !isServer() && window.location !== window.parent.location;

export default isInIframe;
